import { type MemoExoticComponent, memo, type ReactNode } from 'react';

import { ComponentSwitchItem } from './ComponentSwitchItem';
import { ComponentSwitchContext } from './contexts/ComponentSwitch.context';

export type ComponentSwitchProps = {
  value?: string | boolean | number | null;
  children?: ReactNode;
};

export const ComponentSwitchBase = ({
  value = null,
  children = undefined,
}: ComponentSwitchProps) => (
  <ComponentSwitchContext.Provider value={value}>{children}</ComponentSwitchContext.Provider>
);

ComponentSwitchBase.displayName = 'ComponentSwitch';

export const ComponentSwitch: MemoExoticComponent<typeof ComponentSwitchBase> & {
  Item?: typeof ComponentSwitchItem;
} = memo(ComponentSwitchBase);

ComponentSwitch.Item = ComponentSwitchItem;
